import React from "react";
import DatePicker, { registerLocale } from "react-datepicker";
import fr from "date-fns/locale/fr";
import { format, parse, isValid } from "date-fns";
import "react-datepicker/dist/react-datepicker.css";
import "./DatePickerField.css";

registerLocale("fr", fr);

// default year range for the year dropdown when no min / max is given
const DEFAULT_MIN = new Date(1990, 0, 1);
const DEFAULT_MAX = new Date(new Date().getFullYear() + 1, 11, 31);

// Date | "yyyy-MM-dd" string | null -> Date | null (local time, no timezone shift)
const toDate = (v, fmt) => {
  if (!v) return null;
  if (v instanceof Date) return isValid(v) ? v : null;
  const d = parse(v, fmt, new Date());
  return isValid(d) ? d : null;
};

const DatePickerField = ({
  value,
  onChange,
  valueFormat,
  minDate,
  maxDate,
  clearable = false,
  disabled = false,
  placeholder = "jj/mm/aaaa",
  className = "",
  wrapperClassName = "",
  ...rest
}) => {
  const parseFmt = valueFormat || "yyyy-MM-dd";

  const handleChange = (date) => {
    if (!valueFormat) return onChange(date);
    onChange(date ? format(date, valueFormat) : "");
  };

  return (
    <DatePicker
      selected={toDate(value, parseFmt)}
      onChange={handleChange}
      minDate={toDate(minDate, parseFmt) ?? DEFAULT_MIN}
      maxDate={toDate(maxDate, parseFmt) ?? DEFAULT_MAX}
      disabled={disabled}
      isClearable={clearable && !disabled}
      locale="fr"
      dateFormat="dd/MM/yyyy"
      placeholderText={placeholder}
      todayButton="Aujourd’hui"
      showMonthDropdown
      showYearDropdown
      dropdownMode="select"
      showPopperArrow={false}
      autoComplete="off"
      className={`dp-input ${className}`}
      wrapperClassName={`dp-wrapper ${wrapperClassName}`}
      calendarClassName="dp-calendar"
      popperClassName="dp-popper"
      // rendered in <body>: never clipped by a panel with overflow / transform
      portalId="datepicker-portal"
      {...rest}
    />
  );
};

export default DatePickerField;